<template>
  <div>
    <textarea ref="mycode" class="codesql" v-model="value"></textarea>
  </div>
</template>
<script>
import "codemirror/theme/ambiance.css";
import "codemirror/lib/codemirror.css";
import "codemirror/addon/hint/show-hint.css";
let CodeMirror = require("codemirror/lib/codemirror");
require("codemirror/addon/edit/matchbrackets");
require("codemirror/addon/selection/active-line");
require("codemirror/mode/sql/sql");
require("codemirror/addon/hint/show-hint");
require("codemirror/addon/hint/sql-hint");
require("codemirror/addon/edit/closebrackets");
export default {
  data() {
    return {
      editor: null,
    }
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    sqlStyle: {
      type: String,
      default: ''
    },
    readOnly: {
      type: [Boolean, String]
    },
  },
  watch: {
    newVal: { // 监听内部修改value 通知外部
      immediate: true,
      handler(newValue, oldValue) {
        if (this.editor) {
          this.$emit('changeTextarea', newValue)
        }
      }
    },
    value: {
      immediate: true,
      handler(newValue, oldValue) {
        if (this.editor) {
          if (newValue !== this.editor.getValue()) {
            this.editor.setValue(newValue)
          }
        }
      }
    },
  },
  computed: {
    newVal() { // 计算内部修改 val
      if (this.editor) {
        return this.editor.getValue()
      }
    }
  },
  mounted() {
    // let theme = 'ambiance'//设置主题，不设置的会使用默认主题
    this.editor = CodeMirror.fromTextArea(this.$refs.mycode, {
      value: this.value,
      mode: { name: 'text/x-mysql' },//选择对应代码编辑器的语言，我这边选的是数据库，根据个人情况自行设置即可
      indentWithTabs: true,
      smartIndent: true,
      lineNumbers: true,
      autoCloseBrackets: true,
      viewportMargin: 10,
      matchBrackets: true,
      cursorHeight: 1,
      lineWrapping: true,
      readOnly: this.readOnly,
      styleActiveLine: true,
      //theme: theme,
      // autofocus: true,
      extraKeys: { 'Ctrl': 'autocomplete' },//自定义快捷键
      hintOptions: {//自定义提示选项
        // 当匹配只有一项的时候是否自动补全
        completeSingle: false,
        tables: {
          users: ['name', 'score', 'birthDate'],
          countries: ['name', 'population', 'size']
        }
      },
      // 代码折叠
      gutters: [
        "CodeMirror-lint-markers",
        "CodeMirror-linenumbers",
        "CodeMirror-foldgutter"
      ],
      foldGutter: true, // 启用行槽中的代码折叠
    })
    //代码自动提示功能，记住使用cursorActivity事件不要使用change事件，这是一个坑，那样页面直接会卡死
    this.editor.on('inputRead', () => {
      this.editor.showHint()
    })
    const style = '' + this.sqlStyle;
    this.$refs.mycode.nextSibling.setAttribute('style', style);
  },

  methods: {
    setVal() {
      if (this.editor) {
        if (this.value === '') {
          this.editor.setValue('')
        } else {
          this.editor.setValue(this.value)
        }
      }
    }
  }
}
</script>
<style>
.CodeMirror {
  color: black;
  direction: ltr;
  line-height: 22px;
  min-height: 120px;
  max-height: 400px;
  height: 120px;
  resize: vertical;
  border: 1px solid #DCDFE6;
}

.CodeMirror-hints {
  z-index: 9999 !important;
}
</style>